module.exports = __webpack_public_path__ + "static/future-cc517e8f7d1696ae2b0c5f0ee8905342.jpg";